import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, apiError } from "@/context/AuthContext";
import { toast } from "sonner";
import { Skull, Loader2 } from "lucide-react";
import Footer from "@/components/Footer";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(true);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(phone, password, remember);
      toast.success("Đăng nhập thành công");
      navigate("/");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex noise-bg">
      {/* Left visual */}
      <div className="hidden lg:block w-1/2 relative overflow-hidden border-r border-zinc-800">
        <img
          src="https://images.unsplash.com/photo-1503376780353-7e6692767b70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt="car"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black" />
        <div className="relative z-10 h-full flex flex-col justify-end p-12">
          <div className="w-14 h-14 bg-primary flex items-center justify-center mb-6 shadow-[0_0_25px_rgba(230,0,0,0.5)]">
            <Skull className="w-8 h-8 text-white" />
          </div>
          <h1 className="font-display text-5xl font-black tracking-tighter text-white leading-none">
            DANH SÁCH ĐEN
          </h1>
          <p className="text-zinc-400 mt-4 max-w-sm">
            Hệ thống quản lý thông tin khách hàng rủi ro trong ngành cho thuê ô tô tự lái.
          </p>
        </div>
      </div>

      {/* Form */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md animate-fade-up">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-primary flex items-center justify-center">
              <Skull className="w-7 h-7 text-white" />
            </div>
            <span className="font-display text-2xl font-black text-white">DANH SÁCH ĐEN</span>
          </div>
          <h2 className="font-display text-3xl font-bold text-white tracking-tight">Đăng nhập</h2>
          <p className="text-zinc-500 mt-2 mb-8 text-sm">Nhập số điện thoại và mật khẩu của bạn</p>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="block text-xs font-semibold uppercase tracking-[0.1em] text-zinc-400 mb-2">
                Số điện thoại
              </label>
              <input
                data-testid="login-phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="09xxxxxxxx"
                className="w-full bg-[#0a0a0a] border border-zinc-800 text-white rounded-sm px-4 py-3 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors placeholder:text-zinc-600"
                required
              />
            </div>
            <div>
              <label className="block text-xs font-semibold uppercase tracking-[0.1em] text-zinc-400 mb-2">
                Mật khẩu
              </label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full bg-[#0a0a0a] border border-zinc-800 text-white rounded-sm px-4 py-3 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors placeholder:text-zinc-600"
                required
              />
            </div>
            <div className="flex items-center gap-2">
              <input
                id="remember"
                data-testid="login-remember"
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
                className="w-4 h-4 accent-[#E60000] cursor-pointer"
              />
              <label htmlFor="remember" className="text-sm text-zinc-400 cursor-pointer select-none">
                Ghi nhớ đăng nhập
              </label>
            </div>
            <button
              data-testid="login-submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-primary hover:bg-[#ff1a1a] text-white font-bold uppercase tracking-wide rounded-sm px-6 py-3 transition-colors disabled:opacity-50 shadow-[0_0_15px_rgba(230,0,0,0.3)]"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              Đăng nhập
            </button>
          </form>

          <p className="text-zinc-500 text-sm mt-6 text-center">
            Nhà xe chưa có tài khoản?{" "}
            <Link to="/register" data-testid="link-register" className="text-primary hover:text-[#ff1a1a] font-semibold">
              Đăng ký ngay
            </Link>
          </p>
          <div className="mt-8">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}
